/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_TitleInputs */

const en_guide_json_schema_s4_title = /** @type {(inputs: Guide_Json_Schema_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to Use JSON Schema`)
};

const ko_guide_json_schema_s4_title = /** @type {(inputs: Guide_Json_Schema_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema 사용처`)
};

const ja_guide_json_schema_s4_title = /** @type {(inputs: Guide_Json_Schema_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaの使用場面`)
};

/**
* | output |
* | --- |
* | "Where to Use JSON Schema" |
*
* @param {Guide_Json_Schema_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_title = /** @type {((inputs?: Guide_Json_Schema_S4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_title(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_title(inputs)
	return ja_guide_json_schema_s4_title(inputs)
});